import { Component, OnInit } from '@angular/core';
import { User, Doctor } from '../../service/modal/user';
import { FormGroup, Validators, FormBuilder, NgForm } from '@angular/forms';
import { pincode } from '../../service/modal/pincode';
import { Observable, of, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { CampRegistrationService } from '../../service/apiservice/campregistration.service';
import { LoginService } from '../../service/apiservice/login.service';
import { UtilFunctions } from '../../util-functions';
import { NgxSpinnerService } from 'ngx-spinner';
import { HealthHistory } from '../../service/modal/healthhistory';
import { DoctorService } from '../../service/apiservice/doctor.service';
import { UploadFileS3BucketService } from '../../service/apiservice/uploadFileS3Bucket.service';
import { Globals } from '../../globals';
import { PromoCodeService } from '../../service/apiservice/promocode.service';
import { WebcamImage } from 'ngx-webcam';
declare var $;
declare function info_noti(msg: any): any;
declare var printJS;
import swal from 'sweetalert';
import { PromoCode } from '../../service/modal/promocode';
@Component({
  selector: 'app-campregistration',
  templateUrl: './campregistration.component.html',
  styleUrls: ['./campregistration.component.css']
})
export class CampregistrationComponent implements OnInit {

  userInfo: User;
  userForm: FormGroup;
  submitted = false;
  options;
  bloodgroupsDropDown: String[] = ["Don't Know", "A Positive", "A Negative", "B Negative", "B Positive", "AB Negative", "AB Positive", "O Negative", "O Positive"];
  bloodDropDown_SelectedId: number[];
  pincodeDropDown: any;
  pincodeDropDown_SelectedId: number[];
  genderDropDown: String[] = ["Male", "Female", "Other", "Transgender"];
  genderDropDown_SelectedId: number[];
  pincodeList: pincode[];
  filteredOptions: Observable<pincode[]>;
  selectedPincode;
  pincode;
  profileImgCharString: String[] = ['A.png', 'B.png', 'C.png', 'D.png', 'E.png', 'F.png', 'G.png', 'H.png', 'I.png', 'J.png', 'K.png', 'L.png', 'M.png', 'N.png', 'O.png', 'P.png', 'Q.png', 'R.png', 'S.png', 'T.png', 'U.png', 'V.png', 'W.png', 'X.png', 'Y.png', 'Z.png'];
  refrralcode;

  selectedItems = [];
  dropdownSettings = {};
  healthHistoryList: HealthHistory[] = new Array();
  healthhistory = "";

  //opt
  genratedOtp = 0;
  otpCheck;
  otpforlogincheck;

  form: NgForm;

  healthCardData;
  healthCardPath = "";
  healthCardSinglePage;
  //profile image
  selectedFiles: File[] = new Array();
  imgurl: any;
  userObj: User;

  //promoCode
  promocodeInfo: PromoCode = new PromoCode();

  //Doctor
 doctorinfo:Doctor=new Doctor;

 //healthcard preview
hcBackSideForm: FormGroup;
  isHealthCardBackSideForm = false;
  healthCardBackSidePreviewObj: any;
  constructor(private doctorService: DoctorService, private uploadService: UploadFileS3BucketService, private _loginService: LoginService, private spinner: NgxSpinnerService, private router: Router, private loginService: LoginService,
    private promCodeService: PromoCodeService, private global: Globals, private _campRegistrationService: CampRegistrationService, private formBuilder: FormBuilder) { }

  ngOnInit() {
    $(document).ready(function () {
      $("#webCamCampUser").hide();
      $("#snapshotCampUser").hide();
      $('#othertextfield').hide();
      $("#printBtn").hide();
      $("#campUserProfilepic").hide();


    });
    localStorage.setItem("Active Route", this.router.url);
    this.loadEmptyUserRegistarationForm();
    this.getCreateNewSubscribeStatus();
    this.setRefferalCode();

    this.healthHistoryList = [
      { id: 0, itemName: "Acidity" },
      { id: 1, itemName: "Arthritis" },
	    { id:2, itemName: "Asthma" },
	    { id: 3, itemName: "Blood pressure" },
	    { id: 4, itemName: "Cancer / Cancer History" },
	    { id: 5, itemName: "Cholesterol" },
		  { id: 6, itemName: "Diabetes" },
		  { id: 7, itemName: "Epilapsy" },
	    { id: 8, itemName: "Gastric Ulcer" },
		  { id: 9, itemName: "Heart Disease" },
		  { id:10, itemName: "HIV" },
		  { id: 11, itemName: "Hypertension" },
		  { id: 12, itemName: "Other" },
      { id: 13, itemName: "Pregnancy / Breastfeeding" },
      { id: 14, itemName: "Thyroid" }
    ];

    this.dropdownSettings = {
      singleSelection: false,
      text: "Select Health History",
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      // classes:"myclass custom-class"
    };

    //check user add new subscriber or not
    
  }


getCreateNewSubscribeStatus(){
  let user = JSON.parse(UtilFunctions.getLocalStorage('user'));
    this.doctorService.getCreateNewSubscribeStatus(user.user.user_reg_id).subscribe(res => {
      Object.assign(this.doctorinfo,res);
      if(!this.doctorinfo.create_new_subscriber_status){
        // alert("show")
        $("#cantAddNewSubscriberModal").modal("show");
      }
    })

}






  setRefferalCode() {
    let user = JSON.parse(UtilFunctions.getLocalStorage('user'));
    this.loginService.getUserById(user.user.user_reg_id).subscribe(res => {
      this.userForm.controls['usedRefCode'].setValue(res.userRefCode);
    })

  }
  loadEmptyUserRegistarationForm() {
    this.userForm = this.formBuilder.group({
      'user_reg_id': [0, Validators.required],
      'mobileNumber': ['', Validators.required],
      'firstName': ['', Validators.required],
      'middleName': ['',],
      'lastName': ['',],
      'gender': ['', Validators.required],
      'bloodGroup': ['', ''],
      'dob': ['', Validators.required],
      'age': ['', Validators.required],
      'pinCode': ['', Validators.required],
      'postalAddress': ['', Validators.required],
      'emailAddress': ['', Validators.required],
      'otp': ['', Validators.required],
      'address': ['', ''],
      'usedRefCode': ['', ''],
      'personalEmailId': ['', ''],
      'profileImgPath': ['', ''],
      'role': ['patient', ''],
      'emergencyName': ['', ''],
      'emergencyConatctNo': ['', ''],
      'policyDetails': ['', ''],
      'healthHistory': ['', ''],
      'other': ['', ''],
      'promoCode': ['', ''],
      'healthHistorySetCombo':['',''],
    });
  }
  newUserRegisterForm() {
    this.userForm.controls['user_reg_id'].setValue(0);
    this.userForm.controls['middleName'].setValue('');
    this.userForm.controls['lastName'].setValue('');
    this.userForm.controls['gender'].setValue('');
    this.userForm.controls['bloodGroup'].setValue('');
    this.userForm.controls['dob'].setValue('');
    this.userForm.controls['age'].setValue('');
    this.userForm.controls['pinCode'].setValue('');
    this.userForm.controls['postalAddress'].setValue('');
    // this.userForm.controls['emailAddress'].setValue('');
    this.userForm.controls['otp'].setValue('');
    this.userForm.controls['address'].setValue('');
    this.userForm.controls['usedRefCode'].setValue('');
    this.userForm.controls['personalEmailId'].setValue('');
    this.userForm.controls['role'].setValue('patient');
    this.userForm.controls['emergencyName'].setValue('');
    this.userForm.controls['emergencyConatctNo'].setValue('');
    this.userForm.controls['policyDetails'].setValue('');
    this.userForm.controls['healthHistory'].setValue('');
    this.userForm.controls['other'].setValue('');
    this.userForm.controls['promoCode'].setValue('');
    this.userForm.controls['healthHistorySetCombo'].setValue('');
  

  }

  createEmailId() {
    var name = this.userForm.get('firstName').value
    // var emailid=  this.userForm.get('emailAddress').value;
    // var newemailid=emailid.split(".")[0]+"."+this.userForm.get('firstName').value+"@mdhl.in";

    var newemailid = this.userForm.get('mobileNumber').value + "." + name.toLowerCase() + "@mdhl.in"
    this.userForm.controls['emailAddress'].setValue('');
    this.userForm.controls['emailAddress'].setValue(newemailid);
  }

  checkMobileNo(event, mobileno, check) {
    
    if (this.userForm.get('mobileNumber').value.length <= 9) {
      return false
    }


    if (this.userForm.get('mobileNumber').value != "" && this.userForm.get('mobileNumber').value.length == 10) {
      this._loginService.VerifyMobileNo(mobileno)
        .subscribe((response) => {
          //  alert(response)
          if (response === 'Present') {
            // this.mobileNoPresent = true;
            $('#firstName').focus();
          } else if(response === 'Invalid Mobile Number'){
           console.log("Invalid Mobile Number Please Enter Valid Number");
            info_noti("Invalid Mobile Number Please Enter Valid Number");

          }else{
            $('#firstName').focus();
          }
        }, error => {
          console.log(error);
        });
    }

  }
  registerUser(form: NgForm,type) {
    debugger;
    this.submitted = true;

    if (!this.userForm.valid) {
      return ;
    }
   
    if (this.otpCheck === 'Otp Not Match' || this.otpCheck === 'Expired Otp') {
      info_noti("Otp Not Match");
      return ;
    }else{
      this.spinner.show();
    if (this.userForm.get('user_reg_id').value === 0) {
     
      //upload profile img
      for (var i = 0; i < this.selectedItems.length; i++) {
        this.healthhistory = this.healthhistory + this.selectedItems[i].itemName + ",";
        if (this.selectedItems[i].itemName == 'Other') {

        }
      }
      this.userForm.controls['healthHistory'].setValue(this.healthhistory);

      var firstletter = this.userForm.get('firstName').value.charAt(0);
      var profileImgPath = 'https://mdhl.s3.ap-south-1.amazonaws.com/profileImg/';
      for (let i = 0; i < this.profileImgCharString.length; i++) {
        // console.log(this.profileImgCharString[i].charCodeAt(0))
        var first = this.profileImgCharString[i].split(".")[0];
        if (this.profileImgCharString[i].split(".")[0].toString() == firstletter.toLocaleUpperCase().toString()) {
          profileImgPath = profileImgPath + this.profileImgCharString[i];
          break;
        }
      }
      // this.userForm.get('profileImgPath').setValue(profileImgPath);
      this.userForm.controls['profileImgPath'].setValue(profileImgPath);
      if (this.userForm.controls['promoCode'].value !== '') {
        this.userForm.controls['promoCode'].setValue(this.promocodeInfo);
      }else{
        this.userForm.removeControl('promoCode');
      }
      this._campRegistrationService.registerCampUser(this.userForm.value)
        .subscribe((res) => {
          this.submitted = false;

          if (this.selectedFiles.length > 0) {
            this.changeProfilePic(res.user_reg_id);
          }
          if (this.webcamImage != null) {
            this.changeProfilePic(res.user_reg_id);
          }
          this.spinner.hide();
          info_noti('User Register Successfully');
          if(type==='saveAndPrint'){
            ///print function called
            this.loadHealtCardBakSideForm(res, "PrintPage");

            $("#previewORPrintHealthCardModal").modal("show");
          }
          form.reset();
          // window.location.reload();
          this.selectedPincode = "";
          this.selectedItems = [];
          this.healthhistory = "";
          this.clearprofilePic();
          this.promocodeInfo = new PromoCode();
          this.userInfo=new User;

          this.loadEmptyUserRegistarationForm();
          this.setRefferalCode();
         
          // this.router.navigate(['doctordashboard/doctorpage'])
        },
          error => {
            this.spinner.hide();
            info_noti('User Register Failed');
            // alert("User Register Successfully")
            console.log(error);
          })
    } if (this.userForm.get('user_reg_id').value !== 0) {

      for (var i = 0; i < this.selectedItems.length; i++) {

        this.healthhistory = this.healthhistory + this.selectedItems[i].itemName + ",";
        if (this.selectedItems[i].itemName == 'Other') {

        }
      }
      this.userForm.controls['healthHistory'].setValue(this.healthhistory);

      this._campRegistrationService.updateCampRegiserUser(this.userForm.value)
        .subscribe((response) => {
          this.submitted = false;
          // alert("User Register Successfully")
          if (this.selectedFiles.length > 0) {
            this.changeProfilePic(response.user_reg_id);
          }
          if (this.webcamImage != null) {
            this.changeProfilePic(response.user_reg_id);
          }
          this.spinner.hide();
          info_noti('User Updated Successfully');
          if(type==='saveAndPrint'){
            ///print function called
            this.loadHealtCardBakSideForm(response, "PrintPage");
            $("#previewORPrintHealthCardModal").modal("show");
          }
          form.reset();
          // window.location.reload();
          this.selectedPincode = "";
          this.selectedItems = [];
          this.clearprofilePic();
          this.healthhistory = "";
          this.promocodeInfo = new PromoCode();
          this.loadEmptyUserRegistarationForm();
          this.setRefferalCode();
          this.userInfo=new User;
          // this.router.navigate(['doctordashboard/doctorpage'])
        },
          error => {
            this.spinner.hide();
            info_noti('update failed');
            // alert("User Not Register Successfully")
            console.log(error);
          })
    }
  }
  }


  printHealthCard() {
    debugger;
    this.spinner.show();
    // console.log("pageOnePath" + this.healthCardData)
    this.doctorService.createHealthCard(this.userInfo.user_reg_id, 'twopage').subscribe(response => {
      this.spinner.hide();
      this.healthCardData = response;
      if (this.healthCardData != 'undefined') {
        $("#previewHealthCardDoctorModal").modal("show");
        // this.GetPatient_Grid();
      }
    }, err => {
      this.spinner.hide();
    });

    // this.healthCardPageOne=data.healthCardPageOnePath;
    // console.log( "pageOnePath"+this.healthCardPageOne)
    // this.healthCardPageTwo=data.healthCardPageTwoPath;
    // console.log( "pageTwoPath"+this.healthCardPageTwo)

  }

  printHelathCardPageTwo(data) {
    printJS(data);

  }
  printHelathCardPageOne(data) {
    printJS(data);
  }

  clearData() {
    this.healthCardData = "";

  }


  // printHealthCardForSinglePage() {
  //   this.spinner.show();
  //   this.doctorService.createHealthCard(this.userInfo.user_reg_id, 'singlepage').subscribe((response) => {
  //     this.spinner.hide();
  //     this.healthCardSinglePage = response.healthcardpath;
  //     // console.log("healthcard ::::" + this.healthCardSinglePage);

  //     if (this.healthCardSinglePage != 'undefined') {
  //       $("#previewHealthCardSinglePageModal").momodal("show");
  //     }

  //     // this.getUserInfoById();
  //   }, err => {
  //     this.spinner.hide();
  //   });
  // }
  // printHelathCard() {
  //   printJS(this.healthCardSinglePage);
  // }

  getSelectedPincode(event) {
    $("selectFilter").val(event.option.value.pincode);
    this.pincode = event.option.value.pincode;
    this.selectedPincode = event.option.value.pincode + "-" + event.option.value.postofficenamearea + "," + event.option.value.districtname + "," + event.option.value.statename + " [" + event.option.value.divisionname + "]";
    this.userForm.controls['pinCode'].setValue(event.option.value.pincode);
    this.userForm.controls['postalAddress'].setValue(this.selectedPincode);

    // console.log(this.selectedPincode);
  }
  getpincode() {

    if (this.userForm.get('pinCode').value.length == 6) {
      this._campRegistrationService.GetPincode(this.userForm.get('pinCode').value).subscribe((response) => {
        // this.pincodeDropDown=response;
        this.pincodeList = response;
        this.filteredOptions = of(this.pincodeList);
        // console.log(this.pincodeList);
      }, error => {
        this.selectedPincode = "";
      });
    }

  }
  //enter event call also
  checkName(form: NgForm) {
    this.createEmailId();
    if (this.userForm.get('firstName').value != "" && this.userForm.get('firstName').value.length > 0) {

      this._campRegistrationService.VerifyName(this.userForm.get('firstName').value, this.userForm.get('mobileNumber').value)
        .subscribe((response) => {

          if (response == 'Present') {
            this.loginService.FindByNameAndMobileno(this.userForm.get('firstName').value, this.userForm.get('mobileNumber').value).subscribe(response => {
              this.userInfo = response;
              if (this.userInfo != null) {
                $("#CampRegisterUserConfirmUpdateOrAddModal").modal("show");

              }
            }, err => {

            });
          } else if (response == 'Password Not Independent') {
            // this.loadEmptyUserRegistarationForm();
            this.campRegistrationAddUser();


          } else if (response == 'Password Not Dependent') {
            // this.loadEmptyUserRegistarationForm();
            this.campRegistrationAddUser();


          } else {
            // this.loadEmptyUserRegistarationForm();
            this.campRegistrationAddUser();

          }
        }, error => {
          console.log(error);
        });
    }

  }
  campRegistrationAddUser() {
    this.selectedItems = [];
    $("#campUserProfilepic").hide();
    $("#printBtn").hide();
    $('#othertextfield').hide();
    info_noti('New User Registration');
    this.newUserRegisterForm();
    this.selectedPincode = "";
    this.userInfo = null;
    this.setRefferalCode();
 
    this._loginService.GenerateOtp(this.userForm.get('mobileNumber').value, this.userForm.get('firstName').value, 'registration at').subscribe((response) => {
      this.genratedOtp = response.otp_id;
    }, error => {

    });

  }
  campRegisteredUpdateUser() {
    $("#CampRegisterUserConfirmUpdateOrAddModal").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();
    this.imgurl = "";
    this.loadWithDataCustomerForm(this.userInfo);
    $("#campUserProfilepic").show();
    $("#printBtn").show();
    this._loginService.GenerateOtp(this.userForm.get('mobileNumber').value, this.userForm.get('firstName').value, 'update at').subscribe((response) => {
      this.genratedOtp = response.otp_id;
    }, error => {

    });
  }



  checkOtp(opt) {
    if (opt != '') {
      this._loginService.CheckOtp(this.genratedOtp, opt).subscribe((response) => {
        this.otpCheck = response;
        if (this.otpCheck === 'Otp Not Match' || this.otpCheck === 'Expired Otp') {
          //  alert("Otp Not Match")
          this.otpCheck = response;
          info_noti("Otp Not Match");
          $("#otp").focus();
        }

      }, error => {

      });
    } else {
      return false;
    }
  }
  resendOtp() {
    if (this.userInfo.user_reg_id > 0) {
      this._loginService.GenerateOtp(this.userForm.get('mobileNumber').value, this.userForm.get('firstName').value, 'update at').subscribe((response) => {
        this.genratedOtp = response.otp_id;
      }, error => {

      });
    } else {
      this._loginService.GenerateOtp(this.userForm.get('mobileNumber').value, this.userForm.get('firstName').value, 'registration at').subscribe((response) => {
        this.genratedOtp = response.otp_id;
      }, error => {

      });
    }
  }
  // getUserInfoById(name,mobileno) {
  //   this.loginService.FindByNameAndMobileno(name,mobileno).subscribe(response => {
  //     this.userInfo = response;
  //     this.loadWithDataCustomerForm(this.userInfo);
  //     // this.loadHealthHistory();
  //   }, err => { });

  // }
  loadWithDataCustomerForm(userInfo: User) {
    this.userForm = this.formBuilder.group({
      'user_reg_id': [userInfo.user_reg_id, Validators.required],
      'mobileNumber': [userInfo.mobileNumber, Validators.required],
      'firstName': [userInfo.firstName, Validators.required],
      'middleName': [userInfo.middleName,],
      'lastName': [userInfo.lastName,],
      'gender': [userInfo.gender, Validators.required],
      'bloodGroup': [userInfo.bloodGroup, ''],
      'dob': [userInfo.dob, Validators.required],
      'age': [userInfo.age, Validators.required],
      'pinCode': [userInfo.pinCode, Validators.required],
      'postalAddress': [userInfo.postalAddress, Validators.required],
      'emailAddress': [userInfo.emailAddress, Validators.required],
      'address': [userInfo.address, ''],
      'usedRefCode': [userInfo.usedRefCode, ''],
      'personalEmailId': [userInfo.personalEmailId, ''],
      'profileImgPath': [userInfo.profileImgPath, ''],
      'emergencyName': [userInfo.emergencyName, ''],
      'emergencyConatctNo': [userInfo.emergencyConatctNo, ''],
      'policyDetails': [userInfo.policyDetails, ''],
      'healthHistory': [userInfo.healthHistory, ''],
      'other': [userInfo.other, ''],
      'otp': ['', Validators.required],
      'promoCode': [userInfo.promoCode, ''],
      'role': [userInfo.role, ''],
     'healthHistorySetCombo':['','']
    });

    this.selectedPincode = userInfo.postalAddress;
    this.loadHealthHistory();
  }
  checkReferralCode() {

    this.refrralcode = "";
    debugger;
    if (this.userForm.get('usedRefCode').value.length == 10) {
      this._campRegistrationService.checkReferralCode(this.userForm.get('usedRefCode').value).subscribe((response) => {
        if (response == 'Vaild Referral Code') {
          this.refrralcode = response;

        } else {
          this.refrralcode = response;
          $('#userRefCode').val("");
          $('#userRefCode').focus();
        }
      });
    }
  }


  ageCalculator() {

    // let { AgeFromDateString } = require('age-calculator');

    // let ageFromString = new AgeFromDateString(this.userForm.get('dob').value).age;
    let ageFromString = this.getAge(this.userForm.get('dob').value);
    this.userForm.controls['age'].setValue(ageFromString);
    // this.age = ageFromString;

    // console.log("value from ageFromString", ageFromString);

  }


  getAge(dateString) {
    if(dateString!==""){
      var now = new Date();

      var dob = new Date(dateString.substring(0, 4),
        dateString.substring(5, 7) - 1,
        dateString.substring(8, 10), now.getHours(), now.getMonth(), now.getSeconds()
      );
  
  
  
      //Get difference between years
      var years = now.getFullYear() - dob.getFullYear();
      var currMonth = now.getMonth() + 1;
      var birthMonth = dob.getMonth() + 1;
      var months = 0;
      var days = 0;
      //Get difference between months
      months = currMonth - birthMonth;
  
      //if month difference is in negative then reduce years by one 
      //and calculate the number of months.
      if (months < 0) {
        years--;
        months = 12 - birthMonth + currMonth;
        if (now.getDate() < dob.getDate())
          months--;
      } else if (months == 0 && now.getDate() < dob.getDate()) {
        years--;
        months = 11;
      }
  
      //Calculate the days
      if (now.getDate() > dob.getDate())
        days = now.getDate() - dob.getDate();
      else if (now.getDate() < dob.getDate()) {
        var today = now.getMonth();
        now.getMonth(), -1;
        days = now.getMonth() - dob.getMonth() + today;
      }
      else {
        days = 0;
        if (months == 12) {
          years++;
          months = 0;
        }
      }
      //Create new Age object 
      // return new Age(days, months, years);
  
  
      if (years > 0) {
  
        return years + " Years";
      } else if (months > 0) {
  
        return months + " Months";
      } else {
  
        return days + " Days";
      }
    }
  }

  dobBlur() {
    this.ageCalculator();
    // info_noti('Age Calculation Mandatory Please Calculate Age');
  }

  addCancelClick(form: NgForm) {

    form.reset();
    this.loadEmptyUserRegistarationForm();
    // window.location.reload();
    this.selectedItems = [];
    this.selectedPincode = "";
    this.clearprofilePic();
    $("#campUserProfilepic").hide();
    $("#webCamCampUser").hide();
    $("#snapshotCampUser").hide();
    $('#othertextfield').hide();
    $("#printBtn").hide();
    this.setRefferalCode();
    this.userInfo=new User();
    // this.router.navigate(['/dashboard/profile']);
  }


  loadHealthHistory() {
    if (this.userInfo != undefined) {
      if (this.userInfo.healthHistory != null) {
        this.selectedItems = [];
        var healthhistoryarr = this.userInfo.healthHistory.split(",");
        var removeduplicate = Array.from(new Set(healthhistoryarr));
        // console.log(removeduplicate);
        for (var i = 0; i < removeduplicate.length; i++) {
          if (removeduplicate[i] != "") {

            this.healthHistoryList.forEach(element => {
              if (removeduplicate[i] == element.itemName) {
                if (removeduplicate[i] == 'Other') {
                  // this.userForm.controls['Other'].setValue(this.healthhistory);
                  // $('#otherhealthhistory').val(this.userInfo.other);
                  $('#othertextfield').show();
                }
                this.selectedItems.push(element);
              }
            });
          }
        }
        // console.log(this.selectedItems);
      }
    }
  }



  onItemSelect(item: any) {
    // console.log(item);
    if (item.itemName == "Other") {
      $('#othertextfield').show();
    }

    // console.log(this.selectedItems);
  }
  OnItemDeSelect(item: any) {
    // console.log(item);
    if (item.itemName == 'Other') {
      $('#othertextfield').hide();

      this.userForm.controls['other'].setValue('');
    }
    // console.log(this.selectedItems);
  }
  onSelectAll(items: any) {

    // console.log(items);
    for (var i = 0; i < items.length; i++) {
      if (items[i].itemName == 'Other') {
        $('#othertextfield').show();
      }
    }


  }
  onDeSelectAll(items: any) {
    // console.log(items);
    if (items.length == 0) {
      $('#othertextfield').hide();
      this.userForm.controls['other'].setValue('');
    }

  }

  checkPromoCode() {
    if (this.userForm.get('promoCode').value !== "") {
      this.promCodeService.checkPromCodeCampRegister(this.userForm.get('promoCode').value).subscribe(res => {
        Object.assign(this.promocodeInfo, res);
        // console.log(res);

      }, err => {
        info_noti(err.error);
        this.promocodeInfo =null;
      });

    }

  }



  //profile photo


  base64ToByteArray(base64String) {
    try {
      var sliceSize = 1024;
      var byteCharacters = atob(base64String);
      var bytesLength = byteCharacters.length;
      var slicesCount = Math.ceil(bytesLength / sliceSize);
      var byteArrays = new Array(slicesCount);

      for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        var begin = sliceIndex * sliceSize;
        var end = Math.min(begin + sliceSize, bytesLength);

        var bytes = new Array(end - begin);
        for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
          bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
      }
      return byteArrays;
    } catch (e) {
      console.log("Couldn't convert to byte array: " + e);
      return undefined;
    }
  }


  public seconds: number;
  private trigger: Subject<void> = new Subject<void>();

  // latest snapshot
  public webcamImage: WebcamImage = null;
  public triggerSnapshot(): void {
    this.trigger.next();
  }

  public handleImage(webcamImage: WebcamImage): void {
    console.info("received webcam image", webcamImage);
    this.webcamImage = webcamImage;
    $("#webCamCampUser").hide();
    $("#snapshotCampUser").show();
    $("#campUserProfilepic").hide();
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }
  openWebCam() {

    this.imgurl = "";
    $("#snapshotCampUser").hide();
    $("#webCamCampUser").show();
    $("#takephotoCampUser").attr("disabled", true);
    $("#campUserProfilepic").hide();

    // this.triggerSnapshot();
  }
  uploadPicHideWebCam() {
    this.webcamImage = null;
    $("#snapshotCampUser").hide(); false
    $("#webCamCampUser").hide();
    $("#takephotoCampUser").attr("disabled", false);
    $("#campUserProfilepic").hide();
  }

  clearprofilePic() {
    this.imgurl = "";
    this.webcamImage = null;
    $("#snapshotCampUser").hide();
    $("#webCamCampUser").hide();
    $("#takephotoCampUser").attr("disabled", false);
    $("#campUserProfilepic").hide();
    $('#othertextfield').hide();
    $("#printBtn").hide();
   
  }


  onFileChange(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      this.selectedFiles = event.target.files;
      reader.readAsDataURL(event.target.files[0]); // read file as data url

      reader.onload = (event) => { // called once readAsDataURL is completed
        this.imgurl = reader.result;
      }
    }

  }
  changeProfilePic(userid) {
    if (this.webcamImage != null) {
      this.selectedFiles = new Array;
      var bytearray = this.base64ToByteArray(this.webcamImage.imageAsBase64);
      var file = new File([new Blob(bytearray)], "profile", { type: "image/jpeg" });
      this.selectedFiles[0] = file;
    }

    if (this.selectedFiles.length > 0) {

      this.uploadService.uploadCampRegisterUserProfileImg(this.selectedFiles, userid);
    }
    setTimeout(() => {
      if (Globals.attachmentStatus == true) {
        var path = "https://mdhl.s3.ap-south-1.amazonaws.com/" + userid + "/profileImg." + "jpeg";
        this.userObj = new User();
        this.userObj.user_reg_id = userid;
        this.userObj.profileImgPath = path;
        this._loginService.uploadProfileImg(this.userObj).subscribe((response) => {
          if (response != null) {
            this.selectedFiles = new Array;
            this.webcamImage = null;
            Globals.attachmentStatus = false;


          }
        }, err => { });
      } else {
        info_noti("Please Wait For Upload Profile Img")
        this.spinner.hide();
        return false;

      }
    }, 5000);


  }




  removeImage() {
    debugger;
    this.imgurl = "";
    this.selectedFiles = new Array;
    this.webcamImage = null;
    $("#snapshotCampUser").hide();
    $("#webCamCampUser").hide();
    $("#takephotoCampUser").attr("disabled", false);

    if (this.userInfo != null) {
      var firstletter = this.userForm.get('firstName').value.charAt(0);
      var profileImgPath = 'https://mdhl.s3.ap-south-1.amazonaws.com/profileImg/';
      for (let i = 0; i < this.profileImgCharString.length; i++) {
        // console.log(this.profileImgCharString[i].charCodeAt(0))
        var first = this.profileImgCharString[i].split(".")[0];
        if (this.profileImgCharString[i].split(".")[0].toString() == firstletter.toLocaleUpperCase().toString()) {
          profileImgPath = profileImgPath + this.profileImgCharString[i];
          break;
        }
      }

      // this.userObj = new User();
      // this.userObj.user_reg_id = this.userForm.get('user_reg_id').value;
      // this.userObj.profileImgPath = profileImgPath;


      this.userForm.get('profileImgPath').setValue(profileImgPath);
      $("#campUserProfilepic").hide();


      // this._loginService.uploadProfileImg(this.userObj).subscribe((response) => {
      //   if (response != null) {


      //   }
      // }, err => { });
    }
  }



  blockAddNewSubscriber(){
    $("#cantAddNewSubscriberModal").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();
     this.router.navigate(['/doctordashboard/doctorpage'])
  }


//healthCard 



printHealthCardOnSinglePage() {

  let printContents, popupWin;
  printContents = document.getElementById('singlePage').innerHTML;
  popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
  popupWin.document.open();
  popupWin.document.write(`
    <html>
      <head>
     
        <style>
      
  /* Health Card css */
    .td{
      word-wrap:break-word; 
    }
    td.tdnormalfontwithleft{
    
      text-align: left;
      padding: 0px;
      font-family: 'Times New Roman';
    font-size:12px;
      }
      td.tdboldfontwithcenter{
        text-align: center;
      padding: 0px;
    font-family: 'Times New Roman';
      font-weight:bold;
    font-size:12px;
      }
      td.tdnormalfontwithcenter{
      text-align: center;
      padding: 0px;
    font-family: 'Times New Roman';
    font-size:12px;
    }


      .divsizehealthhistory{
       word-wrap:break-word; 
      width:320px;
      height:45px; 
      overflow: hidden !important;
    word-wrap:break-word; 
    }

    .divsizepolicydetails{
      width:320px;
      height:13px; 
      overflow: hidden !important;
    }
    .divsizereferaltext{
      height:11px; 
      overflow: hidden !important;
    }
    .divsizeaddress{
      width:320px;
    display: block; 
    height:28px; 
    overflow: hidden !important;
      }

    .divsizehealthcardbackside{
    width:320px;
    display: block; 
    height:71px; 
    overflow: hidden !important;
  }
  p.healthcardparagraph{
    margin-bottom: 0px;
  }

  .lefttable{
   width: 330px;
    height: 204px;
   border: 1px
    word-wrap:break-word; 
  }

  .maintable{
    table-layout: fixed;
    width: 660px;
    height: 204px;
  }

  table.bordertable{
   border: 1px solid black;
 }
 .qrcode{
  text-align: left;
 }
  p{margin:0; padding:0}
  td{margin:0; padding:0}

  .emergencyDetailsCenter{ 
    text-align:center; 
  
    padding: 0px;
    font-family: 'Times New Roman';
    font-size:12px;
  } 
  .watermarkhealthcardimage
 {
  width: 100px;
  height: 99px;
   background:url('../../../assets/images/watermark.png');
 background-repeat:no-repeat;
  background-position:center;
  }

  .watermarkhealthcard{
   width: 330px;
    height: 200px;
  // opacity:0.6;
  // filter:alpha(opacity=60);
   }
      @page {
        size:8.3in 11.7in;  
        margin: .0in .5in .5in 0.5in; 
        mso-header-margin: .5in; 
        mso-footer-margin: .5in; 
        mso-paper-source: 0;
   }
   
        </style>
      </head>
  <body onload="window.print();window.close()">${printContents}</body>
    </html>`
  );
  popupWin.document.close();
}


loadHealtCardBakSideForm(reponse, printStatus) {
  debugger;
  this.isHealthCardBackSideForm = true;
  var postaladdress = "";
  if (reponse.address != null) {

    if (reponse.postalAddress != null) {

      var addarr = reponse.postalAddress.split("-");
      var addarr1 = addarr[1].split(",");
      var addarr2 = addarr1[1].split("[");

      postaladdress = reponse.address + " " + addarr1[0] + ", " + addarr1[1] + " " + addarr[0] + ", " + addarr2[0].substring(0, 1) + addarr2[0].substring(1, addarr2[0].length).toLowerCase() + ", India";
    } else {
      postaladdress = reponse.pinCode + ", India";
    }
  } else {

    if (reponse.postalAddress != null) {

      var addarr = reponse.postalAddress.split("-");
      var addarr1 = addarr[1].split(",");
      var addarr2 = addarr1[1].split("[");

      postaladdress = addarr1[0] + ", " + addarr1[1] + " " + addarr[0] + ", " + addarr2[0].substring(0, 1) + addarr2[0].substring(1, addarr2[0].length).toLowerCase() + ", India";
    } else {
      postaladdress = reponse.pinCode + ", India";
    }

  }


  var healthhistory = "";
  var other = "";

  if (reponse.healthHistory != null) {
    if (reponse.healthHistory !== "") {

      var historyarr = reponse.healthHistory.split(",");

      for (var i = 0; i < historyarr.length; i++) {
        if (historyarr[i] === "Other") {
          other = reponse.other;
        } else if (historyarr[i] === "") {

        } else {
          healthhistory = healthhistory + historyarr[i] + ", ";
        }
      }
    }
  }
  healthhistory = healthhistory + other;


  this.hcBackSideForm = this.formBuilder.group({
    'pageprint': [printStatus],
    'profileImgPath': [reponse.profileImgPath],
    'mdhlId': [reponse.emailAddress],
    'firstName': [reponse.firstName],
    'lastName': [reponse.lastName],
    'dob': [reponse.dob],
    'mobileNo': [reponse.mobileNumber],
    'gender': [reponse.gender],
    'bloodGroup': [reponse.bloodGroup],
    // 'pinCode': [reponse.pinCode],
    'address': [postaladdress],
    // 'postalAddress':[reponse.postalAddress],
    // 'otherHealthHistory': [reponse.other],
    'healthHistory': [healthhistory],
    'policyDetails': [reponse.policyDetails],
    'emergencyName': [reponse.emergencyName],
    'emergencyContactNo': [reponse.emergencyConatctNo],

    'scanqrcode': ['Scan QR Code'],
    'qrcodelogo': ['https://mdhl.s3.ap-south-1.amazonaws.com/mdhlQrCode.png'],
    'or': ['OR'],
    'visit': ['Visit app.mdhl.in'],
    'issuedby': ['Health Card issued by'],
    'poweredby': [' EasyReach Healthcare Private Limited'],
    'callus': ['Call Us:+918433513351 (Mon-Fri):10.00 AM-06.00 PM (IST)'],
    'hcRefferalText': [reponse.healthCardIssueText],
    'hcBackSideText': [reponse.healthCardBackSideText],

  })

  this.healthCardBackSidePreviewObj = this.hcBackSideForm.value;
  console.log(this.healthCardBackSidePreviewObj);

}

previewHealthCardBakSideClearData() {
  $("#previewORPrintHealthCardModal").modal("hide");
  this.healthCardBackSidePreviewObj = null;
}




  mobileNumberEnter() {
    $('#firstName').focus();
  }
  firstNameEnter() {
    $('#middleName').focus();
  }
  middelNameEnter() {
    $('#lastName').focus();
  }
  lastNameEnter() {
    $('#mdhlId').focus();
  }
  mdhlIdEnter() {
    $('#gender').focus();
  }
  genderEnter() {
    $('#bloodgroup').focus();
  }
  bloodGroupEnter() {
    $('#dob').focus();

  }
  dobEnter() {
    this.ageCalculator();
    $('#age').focus();

  }
  ageEnter() {
    $('#emailId').focus();
  }
  emailIdEnter() {

    $('#userRefCode').focus();
  }
  addressEnter() {

    $('#pincode').focus();
  }
  userRefCodeEnter() {
    $('#promoCode').focus();
    // this.checkReferralCode();
  }
  promoCodeEnter() {
    $('#address').focus();
  }
  pincodeEnter() {
    $('#otp').focus();
  }
  otpEnter(otp) {
    if (otp != '') {
      this._loginService.CheckOtp(this.genratedOtp, otp).subscribe((response) => {
        if (response === 'Otp Not Match' || response === 'Expired Otp') {
          //  alert("Otp Not Match")
          this.otpCheck = response;
          info_noti("Otp Not Match");
          $('#otp').focus();
          return false;
        } else {
          $('#policyDetails').focus();

        }

      }, error => {

      });
    }
  }
  policyDetailsEnter() {
    $('#emergencyContactNo').focus();
  }
  emergencyContactNoEnter() {
    $('#emergencyName').focus();
  }
  emergencyNameEnter() {
    $('#healthhistory').focus();
  }

}


